import axios from "axios";

const api = axios.create({
  baseURL: "https://v5.chatpro.com.br/chatpro-50fae163b7/api/v1",
});

export default api;
